var inspectoresAdmin = angular.module('posicionamientosAdmin', []);

inspectoresAdmin.controller('posicionamientosController', ['$scope', '$location', 'posicionamientosAdminService', 'authenticationInfo', 'authenticationService', function ($scope, $location, posicionamientosAdminService, authenticationInfo, authenticationService) {

    $scope.authentication = authenticationInfo;

    posicionamientosAdminService.getInspecciones()
        .then(function (response) {
            var data = response.data;
            $scope.inspecciones = data;
        });

    $scope.verInspeccion = function (idInspeccion) {
        $location.path('/admin/editarPosicionamientos/' + idInspeccion);
        //$location.path('/Admin/' + idUsuario);

    };
}]);